import axios from "axios";

// Local
// const instance = axios.create({
//   baseURL: "http://127.0.0.1:8000",
// });

// Server
const instance = axios.create({
    baseURL: 'https://musie.space'
});

export default instance;
